export const Config = {
  //API_URL: "https://knomadixserver.knomadixapp.com/RESTService.svc/",
  API_URL: "https://devserver.knomadixapp.com/RESTService.svc/",
  // API_URL_TEST: "https://testserver.knomadixapp.com/Api/KnomadixService/V1/",
  API_URL_TEST:
    "https://knomadixserver.knomadixapp.com/Api/KnomadixService/V1/",
  CHAT_API_URL: "https://knova.knomadixapp.com/",
  API_URL_CLASS_LINK:
    "https://knomadixserver.knomadixapp.com/AdminConsole.svc/",
};
